import React from "react";
import Input from "@cs/components/src/Input";
import Section from "@cs/components/src/Section";
import Checkbox from "@cs/components/src/Checkbox";

interface Props {
  value: PluginConfigItem;
  onChange: (value: PluginConfigItem) => void;
}

const PluginForm = (props: Props) => {
  const { value: pluginConfig, onChange } = props;

  const update =
    (key: keyof PluginConfigItem) => (value: string | boolean | string[]) => {
      onChange({
        ...pluginConfig,
        [key]: value,
      });
    };

  return (
    <Section title="Plugin" color="var(--blue300)" pad>
      <Input
        label="Name"
        required
        value={pluginConfig.title}
        onChange={update("title")}
        autoFocus
      />
      <Input
        label="Description"
        value={pluginConfig.description}
        onChange={update("description")}
        textarea
      />
      <Checkbox
        label="In Development"
        value={pluginConfig.development ?? false}
        onChange={update("development")}
      />
    </Section>
  );
};

export default PluginForm;
